import { render, staticRenderFns } from "./likeComponent.vue?vue&type=template&id=2a93c0e6&scoped=true"
import script from "./likeComponent.vue?vue&type=script&lang=js"
export * from "./likeComponent.vue?vue&type=script&lang=js"
import style0 from "./likeComponent.vue?vue&type=style&index=0&id=2a93c0e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a93c0e6",
  null
  
)

export default component.exports